import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncEventHubHomeOrg({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/EventHubHomeOrg"));
  console.log("Loading", AsyncEventHubHomeOrg.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncEventHubHomeOrg;
